module.exports = __webpack_public_path__ + "media/images/ui__arrowDownInactive--dark-7d613bb3e5cdcfb9f7d492718bba800c.png";